import React from 'react';
import { useEffect } from 'react';
import { Box } from 'dma-ui-kit';
import styled from 'styled-components';

const Container = styled(Box)`
  margin-bottom: 20px;
  max-width: 1250px;
  padding: 0 12px;

  @media (min-width: 768px) {
    padding: 0 24px;
  }

  @media (min-width: 1024px) {
      padding: 0 48px;
  }    

  & h2 {
    margin: 5px 0;
  }
  & h5 {
    margin: 5px 0;
  }
`;

const BlackbaudEmbed = (props) => {
    const { field_form_id, field_form_pkid } = props.paragraph.attributes;

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://sky.blackbaudcdn.net/static/donor-form-loader/2/main.js';

        script.onload = () => {
            if (window.BBDonorFormLoader) {
                window.BBDonorFormLoader.newBlackbaudDonationFormZoned('renxt', field_form_pkid, field_form_id, 'usa')
            }
        };

        document.body.appendChild(script);
    }, []);

    return (
        <Container>
            <div id={`blackbaud-donation-form_${field_form_id}`}></div>
        </Container>
    );
};

export default BlackbaudEmbed;

